export const CONDITIONS = [
  "Endometriosis", "PMOS", "Fibroids", "Adenomyosis",
  "IVF", "Pregnancy", "Postpartum", "Menopause",
  "Gestational diabetes", "High-risk pregnancy", "Postpartum depression",
  "Pregnancy loss", "Miscarriage", "Stillbirth",
];

export const SYMPTOMS = [
  "Pelvic pain", "Heavy periods", "Irregular cycles", "Fatigue",
  "Bloating", "Anxiety", "Insomnia", "Nausea", "Acne", "Hair loss",
];

export const TREATMENTS = [
  "Laparoscopy", "Myomectomy", "IVF", "IUI", "Hormonal therapy",
  "Metformin", "Inositol", "SSRI", "Therapy", "Pelvic floor PT", "Acupuncture", "IUD",
];

export const GOALS = [
  "Trying to Conceive", "Pregnancy", "Postpartum recovery",
  "Pain management", "Cycle regulation", "Mental health",
];

export const STAGES = [
  { id: "TTC", label: "Trying to Conceive" },
  { id: "Pregnancy", label: "Pregnancy" },
  { id: "Postpartum", label: "Postpartum" },
  { id: "Chronic", label: "Chronic Condition" },
  { id: "Menopause", label: "Perimenopause / Menopause" },
];

export const AGE_RANGES = ["18-24", "25-30", "30-35", "35-40", "40+"];

export const HUBS = [
  { id: "Endometriosis", desc: "Living with endo, surgeries, symptoms, sisterhood." },
  { id: "PMOS", desc: "Cycles, cravings, and slow-and-steady wins." },
  { id: "IVF", desc: "The two-week wait, protocols, and holding hope." },
  { id: "Pregnancy", desc: "Milestones, worries, joys, one week at a time." },
  { id: "Pregnancy Loss", desc: "Miscarriage, stillbirth, and healing, support without judgment." },
  { id: "Postpartum", desc: "Recovery, mental health, coming back to yourself." },
  { id: "Fibroids", desc: "Symptoms, myomectomy, and long-term care." },
  { id: "Menopause", desc: "Perimenopause and beyond, no more silence." },
];
